import { LitElement, css, html } from "lit"
import { posts } from "../styles/posts"
const { apiFetch } = window.wp
import { nothing } from "lit"
export class Posts extends LitElement {
	static get properties() {
		return {
			showloadmore: { type: Boolean },
			tags: { type: Array },
			taxonomies: { type: Object },
			initialCount: { type: Number },
			postType: { type: String },
			posts: { type: Array, state: true },
			loading: { type: Boolean, state: true },
			loadingMore: { type: Boolean, state: true },
			itemColumnCount: { type: Number },
			itemRowCount: { type: Number },
			wp: { type: Object },
			offset: { type: Number },
		}
	}

	static get styles() {
		return posts
	}

	constructor() {
		super()
		if (!this.showloadmore) this.showloadmore = false
		this.loading = true
		this.loadingMore = false
		this.posts = []
		this.tags = []
		this.taxonomies = {}
		this.postType = "posts"
		this.initialCount = this.initialCount || 8
		this.offset = 0
		this.wp = window.wp
	}

	getPosts() {
		let url = `/wp/v2/${this.postType}?per_page=${this.initialCount}&offset=${this.offset}`
		//{"gronsta_category":{"id":"gronsta_category","entries":[3]}}
		if (this.taxonomies) {
			Object.keys(this.taxonomies).forEach(key => {
				url += `&${key}=${this.taxonomies[key].include.join(",")}`
			})
		}

		apiFetch({
			path: url,
			method: "GET",
		}).then(postList => {
			this.loading = false
			this.loadingMore = false
			if (postList.length === 0) {
				this.showloadmore = false
				return
			}
			this.posts = this.posts.concat(postList)

			this.offset += this.initialCount
		})
	}

	getPostStyle() {
		return css``
	}

	loadMore() {
		this.loadingMore = true
	}

	renderShowMore() {
		return this.showloadmore
			? html`
					<button @click=${this.getPosts} ?disabled=${this.loadingMore}>
						${this.loadingMore ? "Loading..." : "Visa fler"}
					</button>
			  `
			: nothing
	}

	render() {
		if (this.loading) {
			this.getPosts()

			return html` <h1>Loading...</h1> `
		} else {
			return html`
				<div class="post-list">
                ${this.posts.map(
                    (post, index) => html`
                        <single-post
                            id=${index}
                            class=${index % 4 === 3 ? "full-post" : ""}
                            .post=${post}
                        ></single-post>
                    `
                )}
				</div>
				<div>${this.renderShowMore()}</div>
			`
		}
	}
}
